module.exports = __webpack_public_path__ + "static/media/windchill_chart.720cafb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/windchill_chart.png
// module id = 2525
// module chunks = 0